import { useContext, useEffect } from "react";
import { Table } from "react-bootstrap";
import { isEmpty } from "lodash";
import { useSelector } from "react-redux";

import Breadcrumbs from "../../../utils/Breadcrumbs/Breadcrumbs";
import SiteTitle from "../../../utils/SiteTitle/SiteTitle";
import EmptyData from "../../../utils/EmptyData/EmptyData";
import CardLayout from "../../../utils/CardLayout/CardLayout";
import PaginationList from "../../../utils/PaginationList/PaginationList";
import CustomModal from "../../../utils/CustomModal/CustomModal";
import { convertDate } from "../../../utils";
import { walletAdminContext } from "../../../context/Admin/WalletAdminContext/WalletAdminContext";
import {
  areYouSureMessage,
  toastErrorMessage,
} from "../../../utils/toastMessage/toastMessage";
import { ConvertCurrency } from "../../../utils/Currency/Currency";

const WalletAdmin = () => {
  const {
    wallets,
    limit,
    setLimit,
    totalCount,
    pageNumber,
    setPageNumber,
    handleGetWallets,
    handleDeleteWallet,
  } = useContext(walletAdminContext);

  useEffect(() => {
    handleGetWallets();
  }, [pageNumber, limit]);

  return (
    <>
      <SiteTitle title="کیف پول ها" />
      <Breadcrumbs
        navs={[
          { name: "داشبورد", url: "/Admin/Dashboard", type: "l" },
          { name: "کیف پول ها", type: "a" },
        ]}
        title="لیست کیف پول ها"
      />

      <CardLayout>
        {isEmpty(wallets) ? (
          <EmptyData />
        ) : (
          <>
            <div className="d-flex justify-content-between align-items-center">
              <PaginationList
                setPageNumber={setPageNumber}
                pageCount={totalCount / limit}
              />
              <div>
                <select
                  className="form-control mb-3"
                  onChange={(e) => setLimit(Number(e.target.value))}
                >
                  <option value={10} selected={10 === limit}>
                    10
                  </option>
                  <option value={25} selected={25 === limit}>
                    25
                  </option>
                  <option value={50} selected={50 === limit}>
                    50
                  </option>
                  <option value={75} selected={75 === limit}>
                    75
                  </option>
                  <option value={100} selected={100 === limit}>
                    100
                  </option>
                </select>
              </div>
            </div>
            <Table responsive hover borderless striped>
              <thead className="thead-dark text-center">
                <tr>
                  <th>#</th>
                  <th>نام و نام خانوادگی</th>
                  <th>نام کاربری</th>
                  <th>شماره موبایل</th>
                  <th>تاریخ ایجاد</th>
                  <th>آخرین تغییر</th>
                  <th>موجودی فعلی (ريال)</th>
                  <th className="text-center">
                    تعداد کل :{" "}
                    <span className="badge badge-primary font-weight-bold p-1">
                      {totalCount}
                    </span>
                  </th>
                </tr>
              </thead>
              <tbody className="text-center">
                {wallets.map((_item, index) => (
                  <tr>
                    <td>{index + 1}</td>
                    <td>
                      {_item?.user?.first_name} {_item?.user?.last_name}
                    </td>
                    <td>{_item?.user?.username}</td>
                    <td>{_item?.user?.mobile}</td>
                    <td>{convertDate(_item?.created)}</td>
                    <td>{convertDate(_item?.modified)}</td>
                    <td>
                      <span
                        className={`font-weight-bold ${
                          _item?.current_balance > 0
                            ? "text-success"
                            : "text-danger"
                        }`}
                      >
                        <ConvertCurrency price={_item?.current_balance} />
                      </span>
                    </td>
                    <td>
                      <UserWallet data={_item?.user} />
                      {/* <i
                        onClick={() =>
                          areYouSureMessage(
                            () => handleDeleteWallet(_item),
                            `آیا از حذف کیف پول ${_item?.user?.first_name} ${_item?.user?.last_name} اطمینان دارید؟`
                          )
                        }
                        className="fa fa-trash-alt fa-2x text-danger cursorPointer"
                      /> */}
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </>
        )}
      </CardLayout>
    </>
  );
};

export default WalletAdmin;

export const UserWallet = ({ data }) => {
  const permission = useSelector((state) => state.permission);

  const {
    amount,
    setAmount,
    chargeType,
    setChargeType,
    wallet,
    walletTransactions, // Retrieve transactions from context
    walletTransactionsError,
    reason,
    setReason,
    handleCloseWalletModal,
    handleGetWallet,
    handleEditWallet,
  } = useContext(walletAdminContext);

  const handleSubmit = (type) => {
    if (isEmpty(amount)) return toastErrorMessage("مبلغ الزامی است");

    const amnt = Number(amount);
    if (!Number.isSafeInteger(amnt) || amnt <= 0) {
      return toastErrorMessage("مبلغ باید عددی صحیح و بزرگتر از صفر باشد.");
    }
    if (!reason.trim()) return toastErrorMessage("ثبت دلیل تغییر موجودی الزامی است.");

    areYouSureMessage(
      () => handleEditWallet(amnt, type),
      `آیا از ${type === "dec" ? "کاهش" : "افزایش"} کیف پول ${
        data?.first_name
      } ${data?.last_name} به مبلغ ${amnt} ریال مطمئنید؟`
    );
  };

  if (!permission.wallet_get) return null;

  return (
    <>
      <button
        onClick={() => handleGetWallet(data.pk)}
        className="btn btn-warning mr-2"
      >
        ویرایش کیف پول
      </button>

      <CustomModal
        show={!isEmpty(wallet) && data.pk === wallet?.user?.pk}
        title={`ویرایش کیف پول ${data?.first_name} ${data?.last_name} - ${data?.mobile}`}
        size="lg" // Expanded size to fit transaction history table comfortably
        onHide={handleCloseWalletModal}
      >
        <p className="alert alert-primary text-center">
          موجودی فعلی کیف پول:{" "}
          <ConvertCurrency price={wallet?.current_balance} /> ریال
        </p>

        {permission.wallet_update && (
          <>
            <div>
              <label htmlFor={`wallet-reason-${data?.pk}`}>دلیل تغییر موجودی (الزامی)</label>
              <textarea
                id={`wallet-reason-${data?.pk}`}
                value={reason}
                onChange={(e) => setReason(e.target.value)}
                className="form-control mb-4"
                rows={3}
                required
                placeholder="دلیل تغییر موجودی را وارد کنید..."
              />
            </div>
            <div className="input-group mb-4">
              <div className="input-group-prepend">
                <button
                  className="btn btn-danger"
                  onClick={() => handleSubmit("dec")}
                  disabled={!amount}
                >
                  کاهش
                </button>
              </div>
              <select
                className="form-control text-center"
                value={chargeType}
                onChange={(e) => setChargeType(e.target.value)}
              >
                <option value="normal">عادی</option>
                <option value="gift">هدیه</option>
                <option value="apology">عذرخواهی</option>
              </select>
              <input
                type="number"
                name="amount"
                autoComplete="off"
                placeholder="مبلغ"
                value={amount}
                onChange={(e) => {
                  const val = e.target.value;
                  setAmount(val);
                }}
                className="form-control text-center"
                min={1}
              />
              <div className="input-group-append">
                <button
                  className="btn btn-success"
                  onClick={() => handleSubmit("inc")}
                  disabled={!amount}
                >
                  افزایش
                </button>
              </div>
            </div>
          </>
        )}

        <hr />
        <h6 className="font-weight-bold mb-3 text-center">آخرین تراکنش‌های کیف پول</h6>
        {walletTransactionsError ? (
          <p className="alert alert-warning" role="alert">{walletTransactionsError}</p>
        ) : isEmpty(walletTransactions) ? (
          <p className="text-muted text-center small">تراکنشی برای این کاربر یافت نشد.</p>
        ) : (
          <div className="table-responsive">
            <Table hover borderless size="sm" className="text-center">
              <thead className="thead-light">
                <tr>
                  <th>#</th>
                  <th>عنوان</th>
                  <th>مبلغ (ریال)</th>
                  <th>موجودی جدید</th>
                  <th>تاریخ</th>
                  <th>توضیحات</th>
                </tr>
              </thead>
              <tbody>
                {walletTransactions.map((tx, idx) => {
                  const isDeposit = tx.value > 0;
                  return (
                    <tr key={tx.id || idx}>
                      <td>{idx + 1}</td>
                      <td>
                        <span className="badge badge-secondary">{tx.title || tx.transaction_type}</span>
                      </td>
                      <td>
                        <span className={`font-weight-bold text-${isDeposit ? "success" : "danger"}`}>
                          <ConvertCurrency price={Math.abs(tx.value)} />
                          {isDeposit ? " (+)" : " (-)"}
                        </span>
                      </td>
                      <td>
                        <ConvertCurrency price={tx.running_balance} />
                      </td>
                      <td>{convertDate(tx.created)}</td>
                      <td>{tx.description || "-"}</td>
                    </tr>
                  );
                })}
              </tbody>
            </Table>
          </div>
        )}
      </CustomModal>
    </>
  );
};
